import React, { forwardRef } from 'react'

import { useTranslation } from '../../contexts/I18nContext'

import Styled from './NutritionalFactsTable.styled'

const NutritionalFactsTable = forwardRef(
  ({ className, nutritionalFacts, title, withHumanSentence }, ref) => {
    const { t } = useTranslation()
    return (
      <Styled className={className} ref={ref}>
        <Styled.table>
          <Styled.nutritionalFacts>
            {nutritionalFacts.map((fact) => (
              <Styled.nutritionalFact key={fact.label || fact.id}>
                <Styled.nutritionalFactCell>
                  {fact.label}
                </Styled.nutritionalFactCell>
                <Styled.nutritionalFactCell>
                  {`${fact.amount} ${fact.unit}`}
                </Styled.nutritionalFactCell>
              </Styled.nutritionalFact>
            ))}
          </Styled.nutritionalFacts>
        </Styled.table>
        <Styled.caption>
          {t('RECIPE.NUTRITION_FACTS_DISCLAIMER')}
        </Styled.caption>
        {withHumanSentence && (
          <Styled.nutrionalFactsHuman>
            {t('RECIPE.NUTRITION_FACTS_HUMAN', {
              nutritionalFacts: nutritionalFacts
                .map((fact) =>
                  fact.id === 'ENERC'
                    ? `${fact.amount} ${fact.label}`
                    : `${t('RECIPE.NUTRITION_FACT_HUMAN', {
                        value: fact.amount,
                        unit: fact.unit,
                        label: fact.label,
                      })}`,
                )
                .join(', '),
              title: (title || '').trim(),
            })}
          </Styled.nutrionalFactsHuman>
        )}
      </Styled>
    )
  },
)

NutritionalFactsTable.displayName = 'NutritionalFactsTable'
NutritionalFactsTable.defaultProps = {
  nutritionalFacts: [],
  withHumanSentence: false,
}

export default NutritionalFactsTable
